import { Typography } from "@mui/material";
import HintTooltip from "./HintTooltip";
import { NAME_PRONUNCIATION } from "../utility/constants";
import { landingColors } from "../pages/Landing/landingColors";

const PronunciationHint = () => (
  <HintTooltip
    cardWidth="auto"
    ariaLabel={`Pronounced ${NAME_PRONUNCIATION.respelling}. Show IPA transcription`}
    content={
      <>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: "0.06em",
            color: landingColors.textSecondary,
            mb: 0.5,
          }}
        >
          IPA
        </Typography>
        <Typography
          component="span"
          lang="und-fonipa"
          sx={{
            display: "block",
            fontSize: 18,
            color: landingColors.textPrimary,
            // DM Sans lacks several IPA glyphs; one font avoids per-glyph fallback.
            fontFamily: '"Noto Sans", "Segoe UI", system-ui, sans-serif',
            whiteSpace: "nowrap",
          }}
        >
          {NAME_PRONUNCIATION.ipa}
        </Typography>
      </>
    }
  >
    {NAME_PRONUNCIATION.respelling}
  </HintTooltip>
);

export default PronunciationHint;
